/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/2020-scoreboard.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/2020-scoreboard.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-scoreboard.mdx';

const metadata = {
  slug: "2020-scoreboard",
  title: "2020 Scoreboard",
  author: "Christian Battaglia",
  description: "My personal research scorecard for the 2020 presidential election — tracking candidates, platforms, and stances as a registered independent trying to make an informed decision.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/american-flag.jpeg",
  date: "2019-01-22T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["politics","2020 election","presidential candidates","civic engagement","research","nonpartisan","voting","democracy"],
};

export const Route = createFileRoute('/blog/posts/2020-scoreboard')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-scoreboard',
    image: '/og/blog/2020-scoreboard.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
